import { ExternalFieldData, ExternalFieldSchema } from '../DataSetService/yaml-models.js';
import { primitiveTypes } from '../types.js';

export enum SchemaErrorCode {
  INVALID_EXTERNAL_TYPE,
  INVALID_EXTERNAL_DEFAULT_TYPE,
  INVALID_EXTERNAL_PROPERTY_PATH,
  INVALID_EXTERNAL_FIELD,
  INVALID_RESOLUTION_SCHEMA,
}

export class SchemaError extends Error {
  constructor(private code: SchemaErrorCode, message: string = 'SchemaError') {
    super(message);
  }

  static invalidExternalType(external: ExternalFieldSchema, context: string) {
    return new SchemaError(
      SchemaErrorCode.INVALID_EXTERNAL_TYPE,
      `Invalid external type "${external.type}" in "${context}". Should be a primitive type: ${primitiveTypes}.`)
  }

  static invalidExternalDefaultType(external: ExternalFieldSchema, context: string) {
    return new SchemaError(
      SchemaErrorCode.INVALID_EXTERNAL_DEFAULT_TYPE,
      `Invalid external default value "${JSON.stringify(external.default)}" in "${context}". Expected value of ${external.type} type`)
  }

  static invalidExternalPropertyPath(path: string, context: string) {
    return new SchemaError(
      SchemaErrorCode.INVALID_EXTERNAL_PROPERTY_PATH,
      `Invalid external property name(path) "${path}" in ${context}`)
  }

  static invalidExternalFieldData(doc: ExternalFieldData, context: string) {
    return new SchemaError(
      SchemaErrorCode.INVALID_EXTERNAL_FIELD,
      `Invalid external field "${doc.name}". ${context}`)
  }

  static invalidResolutionSchemaProductsDefinition() {
    return new SchemaError(
      SchemaErrorCode.INVALID_RESOLUTION_SCHEMA,
      `Invalid products field. Must be an array`)
  }

  static productResolutionSchemaTypedMissed(index) {
    return new SchemaError(
      SchemaErrorCode.INVALID_RESOLUTION_SCHEMA,
      `Type is missed in Product Resolution Schema definition at ${index} position`)
  }

  static invalidTypeInProductResolutionSchema(type: string, index: number) {
    return new SchemaError(
      SchemaErrorCode.INVALID_RESOLUTION_SCHEMA,
      `Unregistered type in Product Resolution Schema definition at ${index} position`)
  }
}
